<template>
  <div class="file-list">
    <div class="loading loading-files" v-if="loading"></div>
    <button
      class="file px-0 mx-2 rounded position-relative"
      v-for="(file, index) in files"
      :key="index"
      @dblclick="openFile(file)"
    >
      <span class="actions dropdown position-absolute" style="z-index: 3">
        <button
          class="btn btn-link btn-sm"
          type="button"
          id="dropdownMenuButton"
          data-toggle="dropdown"
        >
          <i class="fa fa-ellipsis-h"></i>
        </button>
        <span class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <a class="dropdown-item" href="#" @click="deleteDocument(file)">{{
            $t("message.delete")
          }}</a>
        </span>
      </span>
      <span
        class="card d-block my-0 file-preview"
        :style="{
          backgroundImage:
            'url(' +
            (file.preview != '' ? file.preview : loading_preview) +
            ')',
          backgroundSize:
            file.preview != ''
              ? file.preview == '/document.png'
                ? '70%'
                : 'cover'
              : 'auto',
        }"
        ><span
          class="overlay"
          :data-dblclick="$t('message.contracts.double_click_to_open')"
        ></span
      ></span>
      <span class="file-title d-block">{{ file.title }}</span>
      <span class="file-date d-block">{{ momentum(file.DocumentDate) }}</span>
      <span class="file-number d-block"
        ># {{ filter_doctype(file.DocTypeTitle) }}-{{
          file.DocumentNumber || file.document_id || file.DocumentID
        }}</span
      >
      <canvas :id="'canvas_file' + index"></canvas>
    </button>

    <b-modal
      id="modal-document"
      size="lg"
      :hide-footer="true"
      :title="$t('message.contracts.single_document')"
      button-size="lg"
    >
      <file-single
        :document="current_document"
        :goods="goods"
        :contract_details="contract_details"
      >
      </file-single>
      <!-- <template v-slot:modal-footer="{ ok, cancel, hide }">
			</template> -->
    </b-modal>
  </div>
</template>
<script>
import pdfjsLib from "pdfjs-dist/webpack.js";
import moment from "moment";
export default {
  name: "file-list",
  props: ["contract", "category", "goods", "contract_details"],
  data() {
    return {
      loading: false,
      files: [],
      default_preview: "/document.png",
      loading_preview: "/tenor.gif",

      current_document: {},
    };
  },
  mounted() {
    this.load(this.category);
    this.$root.$on("process_contract_error", (error_data) => {
      // if (error_data.closeFile) {
      // 		this.current_document = {}
      // 		this.$bvModal.hide('modal-document')
      // }
      var type = "";
      switch (error_data.Subsection) {
        case "Invoice":
          type = "Инвойс";
          break;
        case "Epi":
          type = "ЭПИ";
          break;
        case "PackingList":
          type = "Пакинг лист";
          break;
      }
      var initialFile = this.files.filter((file) => {
        return file.DocumentID == error_data.Id && file.DocType == type;
      });
      if (initialFile !== null && typeof initialFile[0] !== "undefined") {
        this.openFile(initialFile[0]);
        //setTimeout(() => {

        setTimeout(() => {
          this.$root.$emit("open_document_for_error", error_data);
        }, 500);

        //}, 1000)
      }
    });
    this.$root.$on("loadDocuments", (data) => {
      this.category = data.category;
      this.load(data.category);
    });
    this.$root.$on("fileUploaded", (data) => {
      this.load(data.category);
    });

    this.$root.$emit("trigger_navigation", "pre-invoice");
  },
  methods: {
    /**
     * converts human readable doctype from database to machine-comaptible doctype
     * @param {String} doctype 
     * @returns {String}
     */
    dehumanizeDoctype(doctype){
      const types = {
        'Спецификация': 'specification',
        'Инвойс': 'invoice',
        'ГТД': 'sad',
        'ЭПИ': 'epi',
        'ФМ-1': 'fm1',
        'AWB': 'awb',
        'Железнодорожная накладная': 'rwb',
        'CMR': 'cmr',
        'Пакинг лист': 'packaging',
        'Cтраховка ответственности': 'liability-insurance',
        'Cтраховка': 'insurance',
        'Доверенность КТЖ': 'ktg_attorney',
        'Форма М': 'form_m'
      }
      return types[doctype]
    },
    filter_doctype(doctype) {
      switch (doctype) {
        case "Спецификация":
          return "Спецификация";
        case "specification":
          return "Спецификация";
        case "Страховка":
          return "Страховка груза";
        case "САД":
          return "ГТД";
        default:
          return doctype;
      }
    },
    deleteDocument(doc) {
      this.$bvModal
        .msgBoxConfirm(this.$t("message.contracts.document_delete_message"), {
          title: this.$t("message.confirm"),
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: this.$t("message.yes"),
          cancelTitle: this.$t("message.no"),
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            switch (doc.DocType) {
              case "Спецификация":
              case "specification":
                axios
                  .post(
                    window.base +
                      "/Document/DeleteSpecification?doc_id=" +
                      doc.DocumentID,
                  )
                  .then(() => {
                    // axios.get(window.base+'/Document/Delete?doc_id='+doc.DocumentID).then(()=>{
                    this.$root.$emit("loadDocuments", { category: "all" });
                    // })
                  });
                break;
              case "Пакинг лист":
                axios
                  .post(
                    window.base +
                      "/Document/DeletePackingList?list_id=" +
                      doc.DocumentID,
                  )
                  .then(() => {
                    axios
                      .get(
                        window.base +
                          "/Document/Delete?doc_id=" +
                          doc.DocumentID,
                      )
                      .then(() => {
                        this.$root.$emit("loadDocuments", { category: "all" });
                      });
                  });
                break;
              case "Страховка":
              case "Insurance":
                axios
                  .post(
                    window.base +
                      "/Document/deleteInsurance?doc_id=" +
                      doc.DocumentID,
                  )
                  .then(() => {
                    this.$root.$emit("loadDocuments", { category: "all" });
                  });
                break;
              case "Инвойс":
                axios
                  .post(
                    window.base +
                      "/Document/DeleteInvoice?doc_id=" +
                      doc.DocumentID,
                  )
                  .then(() => {
                    this.$root.$emit("loadDocuments", { category: "all" });
                  });
                break;
              case "CMR":
                axios
                  .post(
                    window.base +
                      "/Document/DeleteCMR?doc_id=" +
                      doc.DocumentID,
                  )
                  .then(() => {
                    this.$root.$emit("loadDocuments", { category: "all" });
                  });
                break;
              case "ФМ-1":
                axios
                  .post(
                    window.base +
                      "/Document/DeleteFm1?doc_id=" +
                      doc.DocumentID,
                  )
                  .then(() => {
                    this.$root.$emit("loadDocuments", { category: "all" });
                  });
                break;
              case "ЭПИ":
                axios
                  .post(
                    window.base +
                      "/Document/DeleteEPI?doc_id=" +
                      doc.DocumentID,
                  )
                  .then(() => {
                    this.$root.$emit("loadDocuments", { category: "all" });
                  });
                break;
              case "Cтраховка ответственности":
                axios
                  .post(
                    window.base +
                      "/Document/DeleteLiabilityInsurance?doc_id=" +
                      doc.DocumentID,
                  )
                  .then(() => {
                    this.$root.$emit("loadDocuments", { category: "all" });
                  });
                break;
              case "Железнодорожная накладная":
                axios
                  .post(
                    window.base +
                      "/Document/DeleteRWBill?doc_id=" +
                      doc.DocumentID,
                  )
                  .then(() => {
                    this.$root.$emit("loadDocuments", { category: "all" });
                  });
                break;
              default:
                axios
                  .get(
                    window.base + "/Document/Delete?doc_id=" + doc.DocumentID,
                  )
                  .then(() => {
                    this.$root.$emit("loadDocuments", { category: "all" });
                  });
            }
            // if (doc.DocType == 'Пакинг лист') {
            // 	axios.post(window.base + '/Document/DeletePackingList?list_id='+ doc.DocumentID).then(() => {
            // 		axios.get(window.base+'/Document/Delete?doc_id='+doc.DocumentID).then(()=>{
            // 			this.$root.$emit('loadDocuments', {category: 'all'})
            // 		})

            // 	})
            // }else if (doc.DocType == 'Страховка' || doc.DocType == 'Insurance') {
            // 	axios.post(window.base + '/Document/deleteInsurance?doc_id='+ doc.DocumentID).then(() => {
            // 		this.$root.$emit('loadDocuments', {category: 'all'})
            // 	})
            // } else {
            // 	axios.get(window.base+'/Document/Delete?doc_id='+doc.DocumentID).then(()=>{
            // 			this.$root.$emit('loadDocuments', {category: 'all'})
            // 	})
            // }
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    momentum(dt) {
      var m = moment(dt).format("D.MM.YYYY");
      return m;
    },
    load(category) {
      this.files = [];
      this.loading = true;
      if (category == "all") category = "";
      else category = "&category=" + category;
      axios
        .get(
          window.base +
            "/document?attis_contract_id=" +
            this.contract +
            category +
            "&language=" +
            this.$i18n.locale,
        )
        .then((response) => {
          this.files = response.data;
          this.loading = false;
          this.renderPreviews();
        });
    },
    openFile(file) {
      console.log(file)
      this.$router.push({
        name: 'document-viewer',
        params: {
          type: this.dehumanizeDoctype(file.DocType),
          id: file.DocumentID,
          parent: this.$route.params.id
        }
      })
      // console.log(file)
      // this.current_document = file;
      // this.$bvModal.show("modal-document");
      // var anchor = document.createElement('a');
      // anchor.href = file.file;
      // anchor.target = '_blank';
      // anchor.download = file.title;
      // anchor.click();
    },
    getFileExtention(filename) {
      return filename.split(".").pop();
    },
    renderPreviews() {
      this.files.forEach((file, index) => {
        try {
          if (file.FileType == ".pdf") {
            let pdf_promise = pdfjsLib.getDocument(
              window.base + "/document/getfile/" + file.DocGuid,
            );
            pdf_promise.promise.then((pdf) => {
              this.renderPage(pdf, 1, index);
            });
          } else if (
            _.indexOf([".png", ".jpg", ".jpeg", ".gif"], file.FileType) > -1
          ) {
            this.files[index].preview =
              window.base + "/document/getfile/" + file.DocGuid;
          } else {
            this.files[index].preview = this.default_preview;
          }
        } catch (e) {}
      });
    },
    renderPage(pdf, page_index, file_index) {
      pdf.getPage(page_index).then((page) => {
        var scale = 0.5;
        var viewport = page.getViewport({ scale: scale });
        var canvas = document.getElementById("canvas_file" + file_index);
        var context = canvas.getContext("2d");
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        var renderContext = {
          canvasContext: context,
          viewport: viewport,
        };
        page.render(renderContext).then(() => {
          this.files[file_index].preview = canvas.toDataURL();
        });
        // setTimeout(()=>{
        // this.files[file_index].preview = canvas.toDataURL()
        //this.$set(this.files[file_index].preview, canvas.toDataURL())
        // }, 200)
      });
    },
  },
};
</script>
<style lang="scss">
.file-list {
  height: 500px;
  overflow: auto;
  position: relative;
  // display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  &::-webkit-scrollbar {
    background: #fff;
    border-radius: 3px;
    width: 6px !important;
  }
  &::-webkit-scrollbar-thumb {
    background: #999999;
    border-radius: 3px;
  }
}
.file {
  width: 100px !important;
  height: 180px !important;
  flex-basis: 100px;
  cursor: pointer;
  background: transparent;
  border: 0;
  position: relative;

  .overlay {
    opacity: 0;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    background-image: url(data:image/svg+xml;base64,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);
    background-repeat: no-repeat;
    background-size: 30px;
    background-position: center;
    transition: all 0.5s;
    border-radius: 6px;

    &:after {
      content: attr(data-dblclick); //"Double click to download";
      color: #e3e9ed;
      padding: 0 5px;
      font-weight: bold;
      font-size: 10px;
      margin-top: 80px;
      display: block;
      line-height: 10px;
    }
  }

  .file-title {
    height: 1.4em;
    width: 100%;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .file-number,
  .file-date {
    font-size: 12px;
    line-height: 12px;
    opacity: 0.5;
    text-align: left;
  }
  // overflow: hidden;

  &:focus {
    .overlay {
      opacity: 0.5;
    }
    .card {
      box-shadow:
        0 4px 4px 0 rgba(52, 48, 154, 0.14),
        0 3px 1px -2px rgba(52, 48, 154, 0.2),
        0 1px 5px 0 rgba(52, 48, 154, 0.12);
    }
    // .file-number, .file-date, .file-title{
    // 	background: rgba(52, 48, 154,1);
    // 	color: #fff;
    // }
    // outline: 5px auto -webkit-focus-ring-color !important;
  }
  canvas {
    // visibility: hidden;
    position: absolute;
    display: none;
    // left: -1000px; top: 20000px;
  }
  .file-preview {
    height: 120px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;

    img {
      max-height: 100%;
      max-width: 100%;
      width: 64px;
      margin: auto;
    }
  }
}
.loading-files {
  margin-left: -28px !important;
  margin-top: 0 !important;
  top: 60px !important;
  left: 50% !important;
}
</style>
